import { render, staticRenderFns } from "./file-conf-form.vue?vue&type=template&id=c8abfe92&scoped=true&"
import script from "./file-conf-form.vue?vue&type=script&lang=ts&"
export * from "./file-conf-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8abfe92",
  null
  
)

export default component.exports